import { Helmet, HelmetProvider } from 'react-helmet-async'
import { ToastContainer } from 'react-toastify'
import { ThemeProvider } from 'styled-components/macro'

import { Themes } from '@loadsmart/loadsmart-ui/dist/theming'

import { GlobalStyle } from 'legacy/components/global-style/GlobalStyle'

import { CarrierProvider } from 'auth/ui/context/CarrierContext'
import { ConfigProvider as LegacyConfigProvider } from 'config/ui/ConfigContext'
import { UserAccountProvider } from 'user/ui/UserAccountContext'

import { AnalyticsProvider } from './analytics/AnalyticsContext'
import { ENVIRONMENT, __PROD__ } from './infra/environment'
import { ConfigProvider } from './remote-config'
import { ErrorBoundary } from './ui/components/error-boundary/ErrorBoundary'
import { AuthProvider } from './ui/contexts/authContext'
import { Router } from './ui/router/Router'

const helmetContext = {}

export function App() {
  return (
    <ThemeProvider theme={Themes.Miranda}>
      <HelmetProvider context={helmetContext}>
        <ErrorBoundary>
          <AnalyticsProvider>
            <ConfigProvider>
              <LegacyConfigProvider>
                <AuthProvider>
                  <CarrierProvider>
                    <UserAccountProvider>
                      <Helmet titleTemplate="%s Loadsmart">
                        {!__PROD__ && <title>{ENVIRONMENT ? `[${ENVIRONMENT}]` : null}</title>}
                      </Helmet>
                      <GlobalStyle />
                      <ToastContainer />
                      <Router />
                    </UserAccountProvider>
                  </CarrierProvider>
                </AuthProvider>
              </LegacyConfigProvider>
            </ConfigProvider>
          </AnalyticsProvider>
        </ErrorBoundary>
      </HelmetProvider>
    </ThemeProvider>
  )
}
